import {
  ILiveChatConversation,
  ILiveChatConversationSummary,
  ILiveChatMessage,
  ILiveChatMessagePage,
  ILiveChatQueueStatus,
  ILiveChatQuickReply,
  LiveChatTopic,
} from "../models/ILiveChat";
import { configWithUserToken, configWithUserFileToken } from "../../../services/config";

/** POST /api/livechat/start — açık sohbeti getirir, yoksa yenisini açar. */
export const startLiveChat = (body: {
  topic?: LiveChatTopic;
  orderId?: string | null;
  initialMessage?: string;
  channel?: "CustomerApp" | "DriverApp" | "Web";
}) => {
  return configWithUserToken.post<ILiveChatConversation>("LiveChat/start", {
    topic: body.topic ?? "Unspecified",
    orderId: body.orderId ?? null,
    initialMessage: body.initialMessage ?? null,
    channel: body.channel ?? "Web",
  });
};

/** GET /api/livechat/active — açık sohbet yoksa 404 döner (hata değil, normal durum). */
export const getActiveLiveChat = () => {
  return configWithUserToken.get<ILiveChatConversation>("LiveChat/active");
};

export const getLiveChatConversation = (conversationId: string) => {
  return configWithUserToken.get<ILiveChatConversation>(`LiveChat/${conversationId}`);
};

/** Eski mesajlar. `before` olarak bir önceki sayfanın nextCursor'ı geçilir. */
export const getLiveChatMessages = (
  conversationId: string,
  before?: string | null,
  limit = 30
) => {
  return configWithUserToken.get<ILiveChatMessagePage>(`LiveChat/${conversationId}/messages`, {
    params: { ...(before ? { before } : {}), limit },
  });
};

/** clientMessageId tekrar korumasıdır: aynı id ile yeniden gönderim balon çoğaltmaz. */
export const sendLiveChatMessage = (body: {
  conversationId: string;
  content: string;
  clientMessageId?: string;
}) => {
  return configWithUserToken.post<ILiveChatMessage>("LiveChat/messages", body);
};

/** Fotoğraf gönderimi sohbeti her zaman temsilciye aktarır. */
export const sendLiveChatAttachment = (body: {
  conversationId: string;
  file: File;
  caption?: string;
  clientMessageId?: string;
}) => {
  const formData = new FormData();
  formData.append("conversationId", body.conversationId);
  formData.append("file", body.file);
  if (body.caption) formData.append("caption", body.caption);
  if (body.clientMessageId) formData.append("clientMessageId", body.clientMessageId);

  return configWithUserFileToken.post<ILiveChatMessage>("LiveChat/messages/attachment", formData);
};

export const requestLiveChatAgent = (body: {
  conversationId: string;
  topic?: LiveChatTopic;
  reason?: string;
}) => {
  return configWithUserToken.post<ILiveChatQueueStatus>("LiveChat/request-agent", body);
};

export const getLiveChatQueueStatus = (conversationId: string) => {
  return configWithUserToken.get<ILiveChatQueueStatus>(`LiveChat/${conversationId}/queue`);
};

export const markLiveChatAsRead = (conversationId: string) => {
  return configWithUserToken.post<number>(`LiveChat/${conversationId}/read`);
};

export const closeLiveChat = (body: { conversationId: string; reason?: string }) => {
  return configWithUserToken.post("LiveChat/close", body);
};

export const rateLiveChat = (body: {
  conversationId: string;
  rating: number;
  comment?: string;
}) => {
  return configWithUserToken.post("LiveChat/rate", body);
};

export const getLiveChatHistory = (pageIndex = 0, pageSize = 20) => {
  return configWithUserToken.get<ILiveChatConversationSummary[]>("LiveChat/history", {
    params: { pageIndex, pageSize },
  });
};

/** Yazma alanının altındaki niyet çipleri. */
export const getLiveChatQuickReplies = (topic?: LiveChatTopic) => {
  return configWithUserToken.get<ILiveChatQuickReply[]>("LiveChat/quick-replies", {
    params: topic ? { topic } : undefined,
  });
};
